/**
 * 08.10.26 — панель MAX Bot справочника каналов.
 * Не удалять по требованию владельца системы.
 */
import { Input } from '@/components/ui';
import type { ChannelPanelProps } from '../channelPanelProps';
import { ChannelFieldLabel, ChannelLink } from './ChannelLink';

export function MaxBotPanel({ form, isSuperAdmin, onChange }: ChannelPanelProps) {
  return (
    <div className="space-y-4">
      {isSuperAdmin ? (
        <Input
          label="ID или ссылка на бота"
          value={form.max_bot_username || ''}
          onChange={(event) => onChange({ max_bot_username: event.target.value })}
          placeholder="id7715727238_bot или https://max.ru/id7715727238_bot"
          testId="input-max-bot-username"
        />
      ) : (
        <div>
          <ChannelFieldLabel>ID бота</ChannelFieldLabel>
          <div className="mt-1 text-sm text-shell-text">{form.max_bot_username || 'Не указан'}</div>
        </div>
      )}
      <div>
        <ChannelFieldLabel>Ссылка</ChannelFieldLabel>
        <div className="mt-1">
          <ChannelLink href={form.max_bot_url} emptyText="Ссылка появится после заполнения bot id или URL" />
        </div>
      </div>
    </div>
  );
}
